<template>
  <div id="main" class="app-main">
    <router-view style="height: 100%;width: 100%;"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
    //   theme: this.$store.state.app.themeColor
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style>
/* @import './styles/fonts.css'; */

  html,body {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    /* overflow: hidden; */
  }

  .app-main {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
  ::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    border-radius: 999px;
    border: 5px solid transparent;
  }
  ::-webkit-scrollbar-track {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
  }
  ::-webkit-scrollbar-thumb {
    min-height: 20px;
    background-clip: content-box;
    box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
</style>
